<template>
  <v-container class="d-flex align-center justify-center fill-height">
    <div v-if="!emailEnviado">
      <v-card-title class="justify-center">
        <v-avatar size="80" color="var(--zinnes-primary)">
          <v-icon large color="#FFF">mdi-key</v-icon>
        </v-avatar>
      </v-card-title>

      <v-card-subtitle class="text-center">
        <img src="@/assets/images/Rectangle 3.png" alt="Logo Zinnes" class="mb-4">
        <h3 class="headline mb-2 font-bold">Esqueceu sua senha?</h3>
        <p class="text-color">Não se preocupe, enviaremos instruções de redefinição de senha</p>
      </v-card-subtitle>

      <v-form @submit.prevent="submitForm">
        <v-text-field v-model="password" label="Digite nova senha..." outlined required type="password"
          class="reset-password-field" :error-messages="erro"></v-text-field>
        <v-text-field v-model="password_confirmation" label="Repita nova senha..." outlined required type="password"
          class="reset-password-field" :error-messages="erro"></v-text-field>

        <v-btn type="submit" :loading="loading" :disabled="loading" block large class="mb-2 btn-send font-bold zinnes-primary-btn">
          Enviar
        </v-btn>
      </v-form>

      <v-card-actions class="justify-end">
        <v-btn text class="zinnes-primary-btn" @click="goToLogin">
          <v-icon left>mdi-arrow-left</v-icon> Fazer login
        </v-btn>
      </v-card-actions>
    </div>

    <div v-else class="text-center">
      <div class="flex-column">
        <v-avatar size="80" class="mb-4" color="green">
          <v-icon large color="#FFF">mdi-check</v-icon>
        </v-avatar>
        <img src="@/assets/images/Rectangle 3.png" alt="Logo Zinnes" class="mb-4">
      </div>

      <h3 class="headline mb-2 font-bold">Senha redefinida</h3>
      <p class="text-color">Sua senha foi alterada com sucesso. Faça login com a nova senha.</p>
      <v-btn block large class="mt-4 btn-send font-bold zinnes-primary-btn" @click="goToLogin">
        Fazer login
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { PasswordServer } from '@/server/PasswordServer';
import { capturePasswordResetCredentials } from '@/utils/authNavigationPrivacy';

export default {
  data() {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      emailEnviado: false,
      erro: '',
      service: new PasswordServer(),
      loading: false,
      resetToken: '',
      resetEmail: ''
    };
  },
  created() {
    const credentials = capturePasswordResetCredentials(this.$route, window.history, window.location);
    this.resetToken = credentials.token;
    this.resetEmail = credentials.email;
  },
  methods: {
    async submitForm() {
      if (this.loading) return;

      if (!this.resetToken || !this.resetEmail) {
        this.erro = 'Link de redefinição inválido ou incompleto. Solicite um novo link.';
        return;
      }

      if (!this.password || this.password.length < 8) {
        this.erro = 'A senha deve ter no mínimo 8 caracteres.';
        return;
      }

      if (this.password !== this.password_confirmation) {
        this.erro = 'As senhas não coincidem.';
        return;
      }

      this.erro = '';
      this.loading = true;

      try {
        await this.service.reset({
          password: this.password,
          password_confirmation: this.password_confirmation,
          email: this.resetEmail,
          token: this.resetToken
        });
        this.emailEnviado = true;
      } catch (error) {
        this.erro = this.resetErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
    resetErrorMessage(error) {
      if (!error?.response) {
        return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.';
      }

      if (error?.response?.status === 400) {
        return 'Este link de redefinição é inválido, expirou ou já foi utilizado.';
      }

      if (error?.response?.status === 422) {
        return this.publicValidationMessage(error) || 'Confira os dados informados e tente novamente.';
      }

      if (error?.response?.status === 429) {
        return 'Muitas tentativas. Aguarde alguns minutos antes de tentar novamente.';
      }

      if (error?.response?.status >= 500) {
        return 'Serviço temporariamente indisponível. Tente novamente mais tarde.';
      }

      return 'Não foi possível redefinir a senha.';
    },
    publicValidationMessage(error) {
      const errors = error?.response?.data?.errors;
      const publicFields = ['password', 'password_confirmation', 'email'];
      const normalize = (message) => typeof message === 'string'
        ? message.trim().replace(/\s+/g, ' ').slice(0, 240)
        : '';

      for (const field of publicFields) {
        const fieldErrors = errors?.[field];
        const message = Array.isArray(fieldErrors) ? fieldErrors[0] : fieldErrors;
        const normalizedMessage = normalize(message);

        if (normalizedMessage) return normalizedMessage;
      }

      const generalMessage = normalize(error?.response?.data?.message);
      if (generalMessage && !/\btoken\b/i.test(generalMessage)) return generalMessage;

      return '';
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
p {
  color: #858181 !important;
}

.fill-height {
  min-height: 100vh;
}

.btn-send {
  color: #FFF;
}

.text-color {
  color: #000;
}

.font-bold {
  font-weight: bold;
}

.reset-password-field ::v-deep input {
  color: #FFF;
  caret-color: #FFF;
}

.reset-password-field:not(.error--text) ::v-deep .v-label {
  color: #FFF !important;
}

.reset-password-field:not(.error--text) ::v-deep fieldset {
  border-color: #FFF !important;
}

.email-highlight {
  color: orange;
  font-weight: bold;
}

.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
